import { Component, OnInit, OnDestroy, ViewChild, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Article } from './article.model';
import { ArticleService } from './article.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Subscription, fromEvent } from 'rxjs';
import { distinctUntilChanged, map, debounceTime, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-article-details',
  templateUrl: 'article-details.component.html',
  styleUrls: ['article-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ArticleDetailsComponent implements OnInit, OnDestroy {

  public cdn = environment.cdn;
  public path: string;
  public pageTitle: string;
  public pageContent: string;
  public article: Article;
  public articleContent: any[] = [];
  public path_list = '/';
  public path_details = '/';
  public stickTop = 0;

  constructor(private route: ActivatedRoute, private router: Router, private navigationService: NavigationService, private articleService: ArticleService, private cdr: ChangeDetectorRef) {
    this.path_details = this.router.config.find(r => r.data?.module === 'ArticleDetailsModule')?.data.path || '/';  
    this.path_list = this.router.config.filter(r => r?.data?.module === 'ArticleModule').reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr)?.path || '/';
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.path = params.get('path');
      this.article = null;
      this.articleContent = [];
      this.loadData();
    });
    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;
  }

  loadData() {
    this.articleService.item(this.path).pipe(take(1)).subscribe(article => {
      let fbimage;
      if (article.photos) {
        fbimage = article.photos.find(f => f.featured == 1);
      }
      this.navigationService.setMeta(
        (article.meta_title ? article.meta_title : article.name),
        (article.meta_keywords ? article.meta_keywords : article.name),
        (article.meta_description ? article.meta_description : article.name),
        environment.base + '/'+this.path_details+'/' + article.path,
        (fbimage ? this.cdn+'/articles/'+article.photos_directory+'/'+fbimage.filename : null)
      );
      if (article.photos) {
        const banner = article.photos.find(f => f.banner == 1);
        if (banner) article.banner = this.cdn+'/articles/'+article.photos_directory+'/'+banner.filename
      }
      this.article = article;
      this.navigationService.currentPage.next(article);
      this.cdr.detectChanges();
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['404']);
      } else {
        // console.log(error);
      }
    });
  }

  changeModel(data) {
    this.article[data.field] = data.value;
  }

  ngOnDestroy() {
  }

}
